import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Configuration from "../../../config";
import { isLocalhost } from "../../../helpers/helpers";
import { showLoading } from "../../../reducers/app";
import { fetchUser } from "../../../reducers/auth";
import "./ChatPage.scss";

const ChatPage = () => {
  const profile = useSelector((state) => {
    return (state.auth && state.auth.profile) || null;
  });
  const selectedContract = useSelector(
    (state) =>
      (state.contracts &&
        state.contracts.current &&
        state.contracts.current.id) ||
      null
  );
  const clientCode = useSelector(
    (state) =>
      (state.contracts &&
        state.contracts.current &&
        state.contracts.current.clientCode) ||
      null
  );
  const username = useSelector(
    (state) =>
      (state.auth && state.auth.user && state.auth.user.username) || null
  );
  const safoAccountId = useSelector(
    (state) =>
      (state.auth && state.auth.user && state.auth.user.safoAccountId) || null
  );
  const contracts = useSelector(
    (state) => (state.contracts && state.contracts.list) || []
  );
  const currentCulture = localStorage.getItem("i18nextLng")?.split("-")[0];

  const [, setError] = useState(false);
  const dispatch = useDispatch();

  const userFetched = useSelector((state) => state.auth.userFetched);
  const isUserLogged = profile && profile.name && profile.surname;
  const [getConfigurations, setConfigurations] = useState(null);
  useEffect(() => {
    if (!isUserLogged) {
      dispatch(fetchUser());
    }
    const chatConfigurations = {
      dev: {
        organizationID: "00DMA000003GznN",
        eswConfigDevName: "https_dev_www_gruppocap_it",
        baseURL:
          "https://gruppocap--uat.sandbox.my.site.com/ESWhttpsdevwwwgruppoca1758012681985",
        scriptSrc:
          "https://gruppocap--uat.sandbox.my.site.com/ESWhttpsdevwwwgruppoca1758012681985/assets/js/bootstrap.min.js",
        scrt2URL: "https://gruppocap--uat.sandbox.my.salesforce-scrt.com",
      },
      staging: {
        organizationID: "00DMA000003GznN",
        eswConfigDevName: "https_t_www_gruppocap_it",
        baseURL:
          "https://gruppocap--uat.sandbox.my.site.com/ESWhttpstwwwgruppocap1758012894399",
        scriptSrc:
          "https://gruppocap--uat.sandbox.my.site.com/ESWhttpstwwwgruppocap1758012894399/assets/js/bootstrap.min.js",
        scrt2URL: "https://gruppocap--uat.sandbox.my.salesforce-scrt.com",
      },
      production: {
        organizationID: "00D20000000pBhv",
        eswConfigDevName: "Enhanced_Chatbot_Embedded",
        baseURL:
          "https://gruppocap.my.site.com/ESWEnhancedChatbotEmbed1768497598371",
        scriptSrc:
          "https://gruppocap.my.site.com/ESWEnhancedChatbotEmbed1768497598371/assets/js/bootstrap.min.js",
        scrt2URL: "https://gruppocap.my.salesforce-scrt.com",
      },
    };
    const environment = Configuration.get("REACT_APP_ENVIRONMENT");

    if (environment === "production") {
      setConfigurations(chatConfigurations["production"]);
    } else if (environment === "staging") {
      setConfigurations(chatConfigurations["staging"]);
    } else {
      setConfigurations(chatConfigurations["dev"]);
    }
  }, [isUserLogged, dispatch, selectedContract]);

  useEffect(() => {
    if (getConfigurations) {
      let script = document.createElement("script");
      script.src = getConfigurations.script3;
      script.async = true;
    }
    // eslint-disable-next-line
  }, [
    userFetched,
    selectedContract,
    clientCode,
    selectedContract,
    username,
    currentCulture,
  ]);

  const handleInitChat = useCallback(() => {
    if (!isLocalhost) {
      window.minimizeChat = true;
      const apiKey = Configuration.get("REACT_APP_API_KEY");
      const basePath = Configuration.get("REACT_APP_API_LOG");
      async function getSessionDataAndInitChat(profile) {
        try {
          var path = basePath + "/sessionData";

          const encryptedIpData = await fetch(path, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "x-api-key": apiKey,
            },
            body: "",
          });

          const encryptedIpDataJson = await encryptedIpData.json();
          console.log("sessionData service request ok");
          initEmbeddedMessaging(profile, encryptedIpDataJson.encryptedIp);
        } catch (error) {
          console.error("Error:", error);
          initEmbeddedMessaging(profile, "");
        }
      }
      let initEmbeddedMessaging = function (user, encryptedIp) {
        try {
          let embedded_svc = window.embeddedservice_bootstrap;
          embedded_svc.settings.language = currentCulture;

          let mode = user ? "Privata" : "Pubblica";
          embedded_svc.settings.mode = mode;

          let contratti = contracts
            .reduce((acc, current) => {
              acc.push(current.id);
              return acc;
            }, [])
            .join(",");
          let codici_integra = contracts
            .reduce((acc, current) => {
              acc.push(current.clientId);
              return acc;
            }, [])
            .join(",");
          const piva = user ? user.fiscalCode : null;
          let cfiscale = piva;
          let cod_integra = codici_integra;
          let cod_user_web = safoAccountId;
          let cod_cliente = clientCode;

          var btnAriaLabelExpand =
            currentCulture === "it"
              ? "Espandi finestra chat"
              : "Expand chat window";
          var btnAriaLabelMinimize =
            currentCulture === "it"
              ? "Minimizza finestra chat"
              : "Minimize chat window";

          /* event listeners */

          window.addEventListener("onEmbeddedMessagingReady", (event) => {
            console.log("onEmbeddedMessagingReady event was fired.");
            document.querySelector(".floating-chat").classList.remove("d-none");
            window.embeddedservice_bootstrap.prechatAPI.setHiddenPrechatFields({
              Codice_User_Web: cod_user_web || "",
              Partita_IVA: piva || "",
              Codice_Integra: cod_integra || "",
              Codice_Id_Contratto: contratti,
              Codice_Fiscale: cfiscale || "",
              Codice_Cliente: cod_cliente || "",
              Mode: mode,
              Language: currentCulture,
              Ip_Chiamante: encryptedIp,
            });
          });

          window.addEventListener(
            "onEmbeddedMessagingConversationClosed",
            (event) => {
              console.log(
                "onEmbeddedMessagingConversationClosed event was fired."
              );
              window.location.reload();
            }
          );

          window.addEventListener(
            "onEmbeddedMessagingWindowMinimized",
            (event) => {
              console.log(
                "onEmbeddedMessagingWindowMinimized event was fired."
              );
              window.sessionStorage.setItem("checkChatMinimized", "true");
              document
                .querySelector(".floating-chat")
                .classList.remove("d-none");
              document
                .querySelector(".gcap-fab--icon")
                .classList.remove("chatOpen");
              document
                .querySelector(".gcap-fab--icon")
                .setAttribute("aria-label", btnAriaLabelExpand);
              document
                .querySelector(".gcap-fab--icon")
                .setAttribute("title", btnAriaLabelExpand);
              document
                .querySelector(".floating-chat")
                .classList.remove("isChatOpen");
              document
                .querySelector("body")
                .classList.remove("chatOpenNoScrolling");
              var customMinimizeButton = document.querySelector(
                "#embedded-messaging .customMinimizeButton"
              );
              if (
                customMinimizeButton !== null &&
                customMinimizeButton !== undefined
              ) {
                customMinimizeButton.classList.add("d-none");
              }

              var cookieFloatingBtn = document.querySelectorAll(
                "#ot-sdk-btn-floating:not(.ot-hide) button[class^='ot-floating-button']"
              );
              if (cookieFloatingBtn.length > 0) {
                cookieFloatingBtn.forEach(function (btn) {
                  btn.removeAttribute("tabindex");
                });
              }
            }
          );

          window.addEventListener(
            "onEmbeddedMessagingWindowMaximized",
            (event) => {
              if (navigator.userAgent.indexOf("Mobi") === -1) {
                document
                  .querySelector("body")
                  .classList.add("isDesktopChatVisualization");
              }
              if (
                window.minimizeChat &&
                sessionStorage.getItem("checkChatMinimized") &&
                sessionStorage.getItem("checkChatMinimized") === "true"
              ) {
                console.log(
                  "onEmbeddedMessagingWindowMaximized event was fired but widget should be minimized"
                );
                var chatIframe =
                  window.embeddedservice_bootstrap.utilAPI.getEmbeddedMessagingFrame();
                window.embeddedservice_bootstrap.minimizeIframe(chatIframe, {
                  hasMinimizedNotification: false,
                });
              } else {
                console.log(
                  "onEmbeddedMessagingWindowMaximized event was fired."
                );
                window.sessionStorage.setItem("checkChatMinimized", "false");
                document
                  .querySelector(".floating-chat")
                  .classList.remove("d-none");
                document
                  .querySelector(".gcap-fab--icon")
                  .classList.add("chatOpen");
                document
                  .querySelector(".gcap-fab--icon")
                  .setAttribute("aria-label", btnAriaLabelMinimize);
                document
                  .querySelector(".gcap-fab--icon")
                  .setAttribute("title", btnAriaLabelMinimize);
                document
                  .querySelector(".floating-chat")
                  .classList.add("isChatOpen");
                document
                  .querySelector("body")
                  .classList.add("chatOpenNoScrolling");
                var cookieFloatingBtn = document.querySelectorAll(
                  "#ot-sdk-btn-floating:not(.ot-hide) button[class^='ot-floating-button']"
                );
                if (cookieFloatingBtn.length > 0) {
                  cookieFloatingBtn.forEach(function (btn) {
                    btn.setAttribute("tabindex", "-1");
                  });
                }
                if (navigator.userAgent.indexOf("Mobi") !== -1) {
                  //if is a mobile device
                  var customMinimizeButton = document.querySelector(
                    "#embedded-messaging .customMinimizeButton"
                  );
                  if (
                    customMinimizeButton === null ||
                    customMinimizeButton === undefined
                  ) {
                    var s = document.createElement("button");
                    s.setAttribute("class", "customMinimizeButton");
                    s.classList.add("gc-icon-thick-close");
                    s.setAttribute("aria-label", btnAriaLabelMinimize);
                    s.setAttribute("title", btnAriaLabelMinimize);

                    document
                      .querySelector("#embedded-messaging")
                      .insertBefore(
                        s,
                        document.querySelector("iframe.embeddedMessagingFrame")
                      );

                    s.addEventListener("click", function (e) {
                      var chatIframe =
                        window.embeddedservice_bootstrap.utilAPI.getEmbeddedMessagingFrame();
                      window.minimizeChat = true;
                      window.embeddedservice_bootstrap.minimizeIframe(
                        chatIframe,
                        { hasMinimizedNotification: false }
                      );
                    });
                  } else {
                    customMinimizeButton.classList.remove("d-none");
                    customMinimizeButton.addEventListener(
                      "click",
                      function (e) {
                        var chatIframe =
                          window.embeddedservice_bootstrap.utilAPI.getEmbeddedMessagingFrame();
                        window.minimizeChat = true;
                        window.embeddedservice_bootstrap.minimizeIframe(
                          chatIframe,
                          { hasMinimizedNotification: false }
                        );
                      }
                    );
                  }
                }
              }
            }
          );

          /* end event listeners */

          embedded_svc.init(
            getConfigurations.organizationID,
            getConfigurations.eswConfigDevName,
            getConfigurations.baseURL,
            {
              scrt2URL: getConfigurations.scrt2URL,
            }
          );
        } catch (err) {
          console.error("Error loading Embedded Messaging: ", err);
        }
      };

      if (!window.embeddedservice_bootstrap) {
        var s = document.createElement("script");
        s.setAttribute("src", getConfigurations.scriptSrc);

        s.onload = function () {
          console.log(
            "Initializing chat having included " + getConfigurations.scriptSrc
          );
          getSessionDataAndInitChat(profile);
        };

        document.body.appendChild(s);
      } else {
        console.log("Initializing chat using " + getConfigurations.scriptSrc);
        getSessionDataAndInitChat(profile);
      }
    }
  }, [
    profile,
    contracts,
    safoAccountId,
    currentCulture,
    clientCode,
    getConfigurations,
  ]);

  const handleActivate = useCallback(() => {
    try {
      if (!isLocalhost) {
        if (getConfigurations) {
          if (window.embeddedservice_bootstrap) {
            if (
              window.embeddedservice_bootstrap.settings.mode === "Pubblica" &&
              profile
            ) {
              window.embeddedservice_bootstrap.userVerificationAPI
                .clearSession(true)
                .then(function (success) {
                  console.log("chat session cleared");
                  window.location.reload();
                })
                .catch(function (error) {
                  console.log("Failed to clear chat session");
                })
                .finally(function () {
                  dispatch(showLoading());
                });
            }
          } else {
            // attaching the script to page
            let script = document.createElement("script");
            script.src = getConfigurations.scriptSrc;
            script.async = true;
            if (userFetched) {
              // append the script element to dom
              script.addEventListener("load", handleInitChat);
              document.body.appendChild(script);
            }
          }
        }
      }
    } catch (err) {
      console.log("injection blocked by error ", err);
      setError(true);
    }
  }, [userFetched, handleInitChat, getConfigurations, profile, dispatch]);

  useEffect(() => {
    handleActivate();
    // eslint-disable-next-line
  }, [userFetched, safoAccountId, clientCode, profile]);

  return null;
};

ChatPage.propTypes = {};

export default ChatPage;
